"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _InvoiceDialog = _interopRequireDefault(require("@/views/order/components/InvoiceDialog.vue"));
var _order = require("@/api/order");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InvoiceManagement',
  components: {
    InvoiceDialog: _InvoiceDialog.default
  },
  data: function data() {
    return {
      activeStatus: 'all',
      // 当前激活的Tab
      activeType: '',
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 10,
        invoiceNumber: '',
        customerName: '',
        status: ''
      },
      invoices: [],
      statusCounts: {
        // 各状态发票数量
        all: 0,
        pending: 0,
        issued: 0,
        paid: 0,
        cancelled: 0
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    // 获取发票列表
    getList: function getList(num) {
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;

      // 模拟API请求
      this.invoiceList();
    },
    // 发票列表数据
    invoiceList: function invoiceList() {
      var _this = this;
      console.log(JSON.parse(_jsCookie.default.get('JavaMerInfo')), 'invoiceList');
      var merId = JSON.parse(_jsCookie.default.get('JavaMerInfo')).merId || JSON.parse(_jsCookie.default.get('JavaMerInfo')).merchant.id;
      (0, _order.invoiceList)(_objectSpread(_objectSpread({}, this.tableFrom), {}, {
        merId: merId
      })).then(function (data) {
        _this.tableData.data = data.list;
        _this.tableData.total = data.total;
        _this.listLoading = false;
        console.log(data, '123123');
      });
    },
    // 状态文本
    getStatusText: function getStatusText(status) {
      var statusMap = {
        0: '待开票',
        1: '已开票',
        2: '已拒绝',
        3: '已作废'
      };
      return statusMap[status] || status;
    },
    // 状态标签类型
    getStatusType: function getStatusType(status) {
      var typeMap = {
        pending: 'warning',
        issued: 'primary',
        paid: 'success',
        cancelled: 'danger'
      };
      return typeMap[status] || 'info';
    },
    handleReset: function handleReset() {
      this.tableFrom = {
        page: 1,
        limit: 10,
        invoiceNumber: '',
        customerName: '',
        status: ''
      };
      this.activeType = '';
      this.getList(1);
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 新增发票
    handleAdd: function handleAdd() {
      this.$refs.invoiceDialog.showEdit();
    },
    // 编辑发票
    handleEdit: function handleEdit(row) {
      this.$refs.invoiceDialog.showEdit(row);
    },
    // 查看发票详情
    handleView: function handleView(row) {
      this.$refs.invoiceDialog.showEdit(row, true);
    },
    // 删除发票
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u53D1\u7968 #".concat(row.invoiceNumber, " \u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.getList();
      }).catch(function () {});
    },
    // Tab切换处理
    handleTabChange: function handleTabChange(tab) {
      this.activeStatus = tab.name;
      console.log('this.activeStatus', tab.name);
      this.tableFrom.checkType = this.getStatusText1(tab.name);
      this.tableFrom.page = 1; // 重置到第一页
      this.getList();
    },
    handleSeachList: function handleSeachList() {
      this.tableFrom.checkType = this.getStatusText1(this.activeType);
      this.tableFrom.page = 1; // 重置到第一页
      this.getList();
    },
    // 状态文本
    getStatusText1: function getStatusText1(status) {
      var statusMap = {
        'pending': 0,
        'issued': 1,
        'paid': 2,
        'cancelled': 3,
        'all': ''
      };
      return statusMap[status];
    },
    getStatusText2: function getStatusText2(status) {
      var statusMap = {
        '待开票': 0,
        '已开票': 1,
        '已拒绝': 2,
        '已作废': 3
      };
      return statusMap[status];
    },
    // editGetList 编辑保存
    editGetList: function editGetList(e) {
      var _this3 = this;
      (0, _order.invoiceUpdate)(e).then(function (res) {
        console.log('更新发票成功', res);
        _this3.getList(1);
      });
    }
  }
};